import React from 'react';

function HorizontalLine() {
  return <hr className="border-white-o-10 border-solid" />;
}

export default HorizontalLine;
